/**
 * Seat selection (D17: nothing about a package is hardcoded here).
 *
 * The seat price is a server setting, and this page does not have a route that
 * could tell it what that price is — `GET /api/settings` is ADMIN-only. So the
 * page shows what the donor chooses and lets the server decide what it means: the
 * seat count and the total come back on the donation it creates, and the receipt
 * renders them. Inventing a price on this page would be a hardcoded business
 * parameter (README rule 7) and a number that could disagree with the receipt.
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export interface PackagesPageProps {
  onChoose: (seats: number) => void;
}

export default function PackagesPage({ onChoose }: PackagesPageProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [seats, setSeats] = useState(5);

  return (
    <main data-testid="packages">
      <h1>{t('impact.seatsFunded')}</h1>
      <label htmlFor="seats">
        {t('checkout.seats')}
        <input
          id="seats"
          type="number"
          min="1"
          step="1"
          value={seats}
          onChange={(event) => setSeats(Number(event.target.value))}
        />
      </label>
      <button
        type="button"
        data-testid="choose-seats"
        onClick={() => {
          onChoose(seats);
          navigate('/give');
        }}
      >
        {t('checkout.chooseAmount')}
      </button>
    </main>
  );
}
